<template>
  <form class="social-network-item-form" @submit.prevent="submit">
    <Field
      label="Username/profile URL"
      helpText="Enter your username or copy/paste your profile URL"
      :placeholder="`https://${platform}.com/username`"
      class="list-value-field"
      v-model="platformLink"
    />

    <div class="btn-save">
      <Btn primary>Save</Btn>
    </div>
  </form>
</template>

<script>
import Btn from '@/components/Btn'
import form from '@/mixins/form'

export default {
  name: 'social-network-form',

  data() {
    return {
      platformLink: ''
    }
  },

  mixins: [form],

  props: {
    companyId: String,
    siteId: String,
    platform: String
  },

  computed: {
    username() {
      let isUrl = this.platformLink.includes('http') || this.platformLink.includes('www.')

      if (isUrl) {
        return this.platformLink.substring(this.platformLink.lastIndexOf('/') + 1)
      } else {
        return this.platformLink
      }
    }
  },

  components: {
    Btn
  },

  methods: {
    submit() {
      let data = {
        type: 'social',
        key: this.platform,
        value: this.username
      }

      this.$emit('submit', data)
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.btn-save
  margin-bottom: -100px
</style>
